import { adminRpcClient } from '@/providers/backendClient';
import { Box, Button } from '@mui/material';
import { useCallback, useState } from 'react';
import { useRecordContext } from 'react-admin';
import ReactJson from 'react-json-view';

export const AppTrackerCommandPanel = () => {
  const record = useRecordContext();

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={2}
      alignItems="flex-start"
    >
      <ReactJson
        src={record}
        theme="monokai"
        displayDataTypes={false}
        enableClipboard={true}
        collapsed={2}
        style={{
          backgroundColor: 'transparent',
          fontFamily: 'monospace',
        }}
      />
    </Box>
  );
};

export type DownloadFileButtonProps = {
  filePath: string;
};

export const DownloadFileButton = ({
  filePath,
}: DownloadFileButtonProps) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadFile = useCallback(async () => {
    setIsDownloading(true);

    const uri = await adminRpcClient(
      'PUBLIC_ADMIN_getDataExportsDownloadUri',
      [filePath],
    ).catch(error => {
      alert(`Failed to download file: ${error.message}`);

      return null;
    });

    setIsDownloading(false);

    if (!uri) {
      return;
    }

    const parsedFileName = (filePath || '').replace('/', '-');

    await startFileDownload(uri as string, parsedFileName);
  }, [filePath]);

  return (
    <Button onClick={downloadFile} disabled={isDownloading}>
      {isDownloading ? 'Downloading' : 'Download'} File
      {isDownloading ? '...' : ''}
    </Button>
  );
};

export const startFileDownload = async (
  uri: string,
  filename: string,
) => {
  fetch(uri)
    .then(response => response.blob())
    .then(blob => {
      const downloadUrl = URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = downloadUrl;
      anchor.download = filename;
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      URL.revokeObjectURL(downloadUrl);
    })
    .catch(console.error);
};
